import {IZoneDetailResponse, IZoneInfoState} from "../interfaces/Index";

export const normalizeUCDetailsResponse = (res: IZoneDetailResponse) => {
  let normalizedResponse : IZoneInfoState = {
    cityId: res.city.id,
    zoneId: res.zone.id,
    townId: res.town.id,
    ucId: res.uc.id,
    zoneStatus: res.uc.status,
  };

  return normalizedResponse;
};
